import { createAction, props } from '@ngrx/store';
import { CachedPOSTRequest, CACHED_REQUEST_STATUS } from '../../classes/cached-request';

export const addRequestToQueue = createAction(
    '[PaceOffline] add http call to queue',
    props<{ request: CachedPOSTRequest }>(),
);
export const removeRequestFromQueue = createAction(
    '[PaceOffline] remove http call from queue',
    props<{ request: CachedPOSTRequest }>(),
);
export const updateRequestInQueue = createAction(
    '[PaceOffline] update request in queue',
    props<{ requestStatus: CACHED_REQUEST_STATUS }>(),
);

export const synchronizeQueue = createAction('[PaceOffline] sendOfflineData all requests in queue');
